import { POSLeaderboardComponent } from "@/app/infrastructures/dependencies/modules/POSLeaderboardComponent";
import store from "@/store";
import { container } from "tsyringe";
import { Action, getModule, Module, VuexModule } from "vuex-module-decorators";
import { POSLeaderboardPresenter } from "../presenters/POSLeaderboardPresenter";
import { SummaryApiRequest } from "@/data/payload/api/PosLeaderboard";
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import { POSLeaderboardListRequest } from "@/data/payload/api/POSLeaderboardApiRequest";
POSLeaderboardComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "POSLeaderboard"
})
class POSLeaderboardStore extends VuexModule {
  @Action
  public getSummary(params: SummaryApiRequest): Promise<PosLeaderboard> {
    const presenter = container.resolve(POSLeaderboardPresenter);
    return presenter.getSummary(params);
  }

  @Action
  getLeaderboardList(params: POSLeaderboardListRequest) {
    const presenter = container.resolve(POSLeaderboardPresenter);
    return presenter.getLeaderboardList(params);
  }

  @Action
  getConfig(params: SummaryApiRequest) {
    const presenter = container.resolve(POSLeaderboardPresenter);
    return presenter.getConfig(params);
  }
}

export const POSLeaderboardController = getModule(POSLeaderboardStore);
